<template>
  <div class="wc-empty">
    <div class="wc-empty__icon"></div>
    <div class="wc-empty__text">{{ text }}</div>
    <button v-if="retry" class="wc-empty__btn" @click="$emit('retry')">点击重试</button>
    <button v-if="actionText" class="wc-empty__btn" @click="$emit('action')">{{ actionText }}</button>
  </div>
</template>

<script>
export default {
  name: 'WorldCupEmptyState',
  props: {
    text: {
      type: String,
      default: '暂无数据'
    },
    retry: {
      type: Boolean,
      default: false
    },
    actionText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.wc-empty {
  padding: 36px 16px;
  text-align: center;
  color: #8a9099;
}

.wc-empty__icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
}

.wc-empty__text {
  font-size: 14px;
  line-height: 20px;
}

.wc-empty__btn {
  margin-top: 14px;
  padding: 8px 18px;
  border: 0;
  border-radius: 18px;
  color: #5a4300;
  background: #f6c343;
  font-size: 14px;
}
</style>
